export default __webpack_public_path__ + "static/media/star_review_filled.321c415f.svg";